interface BundleSpecialIds {
  discount?: number[] | null;
  qualify?: number[] | null;
}

interface ProductWithStoreSpecialIds {
  applicable_any_discountable_special_ids?: number[] | null;
  applicable_any_qualifier_special_ids?: number[] | null;
  applicable_bulk_special_ids?: number[] | null;
  applicable_bundle_special_ids?: BundleSpecialIds | null;
  applicable_cart_total_special_ids?: number[] | null;
  applicable_special_ids?: number[] | null;
}

export const getApplicableStoreSpecialIds = (
  product: ProductWithStoreSpecialIds | null | undefined
) =>
  new Set([
    ...(product?.applicable_any_discountable_special_ids ?? []),
    ...(product?.applicable_any_qualifier_special_ids ?? []),
    ...(product?.applicable_bulk_special_ids ?? []),
    ...(product?.applicable_cart_total_special_ids ?? []),
    ...(product?.applicable_special_ids ?? []),
    ...(product?.applicable_bundle_special_ids?.discount ?? []),
    ...(product?.applicable_bundle_special_ids?.qualify ?? []),
  ]);
